module.exports = __webpack_public_path__ + "img/cg_speed_roulette_live.d6836d6.jpg";